export default {
  methods: {
    setPageContentAccessibility(isHidden) {
      const elements = [
        document.querySelector('header'),
        document.querySelector('footer'),
        document.querySelector('main'),
        document.querySelector('#skip-links'),
        document.querySelector('#sidebar-main-navigation')
      ]

      const filteredElementsByContains = elements.filter((el) => el && !el.contains(this.$el))

      elements.forEach((el) => {
        if (el) {
          this.toggleAriaHiddenAttribute(el, isHidden)
        }
      })

      filteredElementsByContains.forEach((el) => {
        if (el) {
          this.toggleInertAttributes(el, isHidden)
        }
      })
    },
    toggleAriaHiddenAttribute(el, isHidden) {
      const ariaValue = isHidden ? 'true' : 'false'
      el.setAttribute('aria-hidden', ariaValue)
    },
    toggleInertAttributes(el, isHidden) {
      if (isHidden) {
        el.setAttribute('inert', '')
      } else {
        el.removeAttribute('inert')
      }
    }
  }
}
